'use strict';

var Dropdown = require('./lib/dropdown');
var Calendar = require('./lib/calendar');
var MobileVisibility = require('./lib/mobile-visibility');
var DropdownSearch = require('./lib/dropdown-search');

// Constructor
var Filters = function() {

  var self = this;

  self.config = {
    'filters'               :  $('.filters'),

    // Actions
    'filterItem'            :  $('.filters__actions-item'),
    'button'                :  $('.filters__actions-button'),

    // Dropdowns
    'dropdown'              :  $('.filters__dropdown'),
    'dropdownList'          :  $('.filters__dropdown-list'),
    'dropdownItem'          :  $('.filters__dropdown-item'),
    'dropdownInput'         :  $('.filters__dropdown-input'),
    'dropdownContent'       :  $('.filters__dropdown-content'),
    'dropdownItemTemplate'  :  $('.filters__dropdown-item-template'),

    // Calendar
    'calendar'              :  $('.filters__calendar'),
    'calendarOuter'         :  $('.filters__calendar-outer'),
    'calendarInner'         :  $('.filters__calendar-inner'),
    'calendarEventsEl'      :  $('#filterCalendarEvents'),
    'calendarTemplateEl'    :  $('#filterCalendarTemplate'),

    // Mobile visibility
    'showContent'           :  $('.filters__show-content'),
    'content'               :  $('.filters__content'),
    'container'             :  $('.filters__container')
  }

  self.init = function() {
    new MobileVisibility(self.config).init();
    new Dropdown(self.config).init();
    new DropdownSearch(self.config).init();
    new Calendar(self.config).init();
  }
};

module.exports = Filters;
